export default async function setMobileAppState(
  { state },
  {
    isPartnerApp,
    deviceRegistrationId,
    askedPushNotificationPermission,
    geolocationPermission,
    features,
  },
) {
  state.set(['mobileApp', 'isPartnerApp'], isPartnerApp === true);
  state.set(['mobileApp', 'deviceRegistrationId'], deviceRegistrationId);
  state.set(['mobileApp', 'askedPushNotificationPermission'], askedPushNotificationPermission);
  state.set(['mobileApp', 'geolocationPermission'], geolocationPermission);
  state.set(['mobileApp', 'features'], features || {});
  state.commit();
}
